export default [
  {
    title: 'Loterías',
    url: '/loterias'
  },
  {
    title: 'Resultados',
    url: '/resultados'
  },
  /*{
    title: 'Recargas',
    url: '/recargas'
  },*/
  /* {
    title: 'Nosotros',
    url: '/nosotros/nuestra-empresa'
  }, */
  {
    title: 'Productos',
    url: '/productos'
  }
  /* {
    title: 'Puntos Gana',
    url: '/puntos-gana'
  },
  {
    title: 'Contáctenos',
    url: '/contacto/pqrs'
  } */
];
